<template>
  <div class="SelectPractice">
    <div class="gept_main_bg p-2">
      <h6 class="text-white text-xl lg:text-3xl font-semibold text-center">請選擇要練習的項目</h6>
    </div>
    <div class="flex justify-center">
      <router-link :class="{ 'opacity-25': writingArr.length < 1 }" :to="{ name: recordRoute, params: { select_id: $route.params.select_id, practice_type: 'writing' } }" class="px-2 md:px-5 cursor-pointer">
        <img src="@/assets/image/gept/p01.png" alt="" class="object-contain mx-auto">
      </router-link>
      <router-link :class="{ 'opacity-25': speakingArr.length < 1 }" :to="{ name: recordRoute, params: { select_id: $route.params.select_id, practice_type: 'speaking' } }"  class="px-2 md:px-5 cursor-pointer">
        <img src="@/assets/image/gept/p02.png" alt="" class="object-contain mx-auto">
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SelectType',
    metaInfo: {
      title: '使用指南'
    },
    props: {
      speakingArr: {
        type: Array
      },
      writingArr: {
        type: Array
      }
    },
    data () {
      return {
        recordRoute: 'practice_speaking'
      }
    },
    components: {
    },
    mounted () {
      if (this.$route.name === 'formal_exam') {
        this.recordRoute = 'formal_exam'
      }
    },
    methods: {
    }
  }
</script>
<style lang="scss" scoped>

</style>
